"use strict";
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarnIfSubscriptionsAuthorizationMissing = WarnIfSubscriptionsAuthorizationMissing;
const get_directive_names_1 = require("../utils/get-directive-names");
function WarnIfSubscriptionsAuthorizationMissing(subscriptions) {
    return function () {
        let warningAlreadyIssued = false;
        return {
            ObjectTypeDefinition(objectType) {
                if (warningAlreadyIssued || !subscriptions) {
                    return;
                }
                const directiveNames = (0, get_directive_names_1.getDirectiveNames)(objectType);
                if (directiveNames.includes("authorization") &&
                    !directiveNames.includes("subscriptionsAuthorization")) {
                    console.warn("'@subscriptionsAuthorization' not found on a type/field which has '@authorization' - subscriptions events are not subject to the authorization rules specified in '@authorization' directives.");
                    warningAlreadyIssued = true;
                }
            },
        };
    };
}
//# sourceMappingURL=subscriptions-authorization-missing.js.map